import { isLocalParticipantModerator, isParticipantModerator } from "../base/participants/functions";
// Selector to get the share screen moderation state
const getState = (state) => state['features/shareScreen-moderation'];
// Check if share screen moderation is enabled for all participants
export const isEnableBanAllShareScreen = (state) => getState(state)?.enabled;
// Check if the local participant is allowed to share screen
export const isLocalParticipantCanShareScreen = (state) => {
    if (isLocalParticipantModerator(state)) {
        return true;
    }
    const { canShareScreen } = getState(state);
    if (canShareScreen !== undefined) {
        return canShareScreen;
    }
    return !isEnableBanAllShareScreen(state);
};
export const getScreenShareWheelEvent = (state) => getState(state)?.wheelEvent;
// Check if a specific participant is approved to share screen
export const isParticipantApprovedShareScreen = (participantId, state) => getState(state)?.whitelist[participantId];
// Check if a specific participant is rejected from sharing screen
export const isParticipantRejectedShareScreen = (participantId, state) => getState(state)?.blacklist[participantId];
// Check if a participant is banned from sharing screen
export function isBannedShareScreen(participant, state) {
    if (participant.local) {
        return !isLocalParticipantCanShareScreen(state);
    }
    // Moderators cannot be banned from sharing screen
    if (isParticipantModerator(participant)) {
        return false;
    }
    // If share screen moderation is enabled for all participants
    if (isEnableBanAllShareScreen(state)) {
        return !isParticipantApprovedShareScreen(participant.id, state);
    }
    return Boolean(isParticipantRejectedShareScreen(participant.id, state));
}
